import { gql } from "@apollo/client";

const RENEW_BASKET = gql`
    mutation renewBasket($basketId: ID!) {
        renewBasket(input: { basketId: $basketId })
    }
`;

export default RENEW_BASKET;
